import React from "react";
import { Link } from "react-router-dom";
import Fade from "react-reveal/Fade";

const ContactCTA = () => {
  const whatsappUrl = "https://wa.me/919327708369?text=Hi Gopi, I'd like to talk about a project!";

  return (
    <section className="section-contact-cta">
      <Fade bottom>
        <div className="contact-cta-wrapper">

          <div className="contact-cta-content">
            <h3>
              React Native Developer focused on{" "}
              <span className="highlight">reliable</span>,{" "}
              <span className="highlight">maintainable</span> apps.
            </h3>

            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="contact-cta-button">
              Start a Conversation
              <span className="btn-icon">→</span>
            </a>
          </div>

          {/* Decorative blobs */}
          <div className="cta-blob blob-1"></div>
          <div className="cta-blob blob-2"></div>

        </div>
      </Fade>
    </section>
  );
};

export default ContactCTA;
